export const REGISTER_USER = 'atlas/Resiter/REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'atlas/Resiter/REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'atlas/Resiter/REGISTER_USER_ERROR';
